// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ReactElement, type ComponentProps, forwardRef } from 'react';
import DropdownMenu, { type DropdownItemGroup } from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';
import { IconButton } from '@atlaskit/button/new';
import { mergeRefs } from '@atlassian/jira-merge-refs/src/index.tsx';

type Props = {
	isLoading?: boolean;
	children: ReactElement<ComponentProps<typeof DropdownItemGroup>>;
	testId?: string;
	label?: string;
};

export const MeatBallMenu = forwardRef(
	({ children, isLoading = false, testId, label = '' }: Props, ref) => {
		return (
			<span>
				<DropdownMenu
					placement="bottom-end"
					trigger={({ triggerRef, ...props }) => (
						<IconButton
							{...props}
							ref={mergeRefs(triggerRef, ref)}
							spacing="compact"
							interactionName="auto-generated.jira-issue-view-ecosystem.common.button"
							testId={testId}
							isLoading={isLoading}
							icon={() => <MoreIcon LEGACY_size="small" label="" />}
							appearance="subtle"
							label={label}
						/>
					)}
				>
					{children}
				</DropdownMenu>
			</span>
		);
	},
);
